import React from 'react';
import { View, Text, StyleSheet, useWindowDimensions } from 'react-native';
import { useCustomTheme } from '../../contexts/useCustomTheme';
import THEME from '../../config/theme';
import { ADMIN_COLORS } from '../../config/theme/adminColors';

const Privacy = ({ privacyData = [] }) => {
  const { customFont } = useCustomTheme();
  const { width } = useWindowDimensions();
  const isMobile = width < 640;

  // Mantém as fontes da MARCA DO CLIENTE; apenas cores neutras e ritmo de leitura.
  const headingFont = customFont?.fontFamilySubtitle || THEME.FONTFAMILY.MEDIUM;
  const textFont = customFont?.fontFamilyText || THEME.FONTFAMILY.REGULAR;

  return (
    <View style={[styles.container, { paddingHorizontal: isMobile ? 20 : 36 }]}>
      {privacyData.map((element, index) => (
        <View key={index} style={index > 0 ? styles.sectionGap : null}>
          <Text style={[styles.heading, { fontFamily: headingFont }]}>{element.subtitle}</Text>
          {(element.paragraphs || []).map((item, subIndex) => (
            <Text key={subIndex} style={[styles.paragraph, { fontFamily: textFont }]}>
              {item.text}
            </Text>
          ))}
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: 16,
  },
  sectionGap: {
    marginTop: 24,
  },
  heading: {
    color: ADMIN_COLORS.ink,
    fontSize: 19,
    fontWeight: '700',
    marginBottom: 4,
  },
  paragraph: {
    color: ADMIN_COLORS.label,
    fontSize: 15.5,
    lineHeight: 24,
    textAlign: 'justify',
    marginTop: 10,
  },
});

export default Privacy;
